<template>
  <el-main>
    <router-view :key="key"/>
    <float-btn-group/>
  </el-main>
</template>

<script>
import FloatBtnGroup from "@/layout/components/FloatBtnGroup.vue";

export default {
  name: "CMain",
  components: {FloatBtnGroup},
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped lang="scss">
.el-main {
  padding: 0;
  overflow: unset;
  background-color: #eff4fe;
}
</style>